import { z } from "zod";

import { branded } from "@/lib/helpers/branded-helper";

export const simpleCompanyDtoSchema = z.object({
  id: branded.companyId,
  name: z.string(),
});

export type TSimpleCompanyDto = z.infer<typeof simpleCompanyDtoSchema>;
